import * as React from 'react';
import { IgcTabsComponent as Component } from 'igniteui-webcomponents';
import type { IgcTabsComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Tabs organize and allow navigation between groups of content that are related and at the same level of hierarchy.
 *
 * The `<igc-tabs>` component allows the user to navigate between multiple `<igc-tab>` elements.
 * It supports keyboard navigation and provides API methods to control the selected tab.
 * @slot  - Renders the `IgcTabComponents` inside default slot.
 * @fires igcChange - Emitted when the selected tab changes.
 * @csspart start-scroll-button - The start scroll button displayed when the tabs overflow.
 * @csspart end-scroll-button - The end scroll button displayed when the tabs overflow.
 * @csspart selected-indicator - The indicator that shows which tab is selected.
 * @class
 */
export const IgrTabs = /* @__PURE__ */ createComponent({
  tagName: 'igc-tabs',
  displayName: 'IgrTabs',
  elementClass: Component,
  react: React,
  events: {
    onChange: 'igcChange' as EventName<IgcTabsComponentEventMap['igcChange']>,
  },
});

export type IgrTabs = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrTabsModule = Component;
